import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  cover: string;
  author: string;
  categories: string[];
  status: string;
  updateTime: string;
  chapters: number;
  views: number;
  rating: number;
  isNew?: boolean;
}

const categoryNameMap: Record<string, string> = {
  romance: '恋爱',
  fantasy: '奇幻',
  action: '动作',
  drama: '剧情',
  comedy: '搞笑',
  thriller: '悬疑',
  daily: '日常',
};

export default function ComicCard({
  id,
  title,
  cover,
  author,
  categories: comicCats,
  status,
  chapters,
  views,
  rating,
  isNew,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`${title} - 韩国漫画全集免费在线阅读`}
        />
        {isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs font-semibold px-2 py-0.5 rounded-md whitespace-nowrap">
            NEW
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {rating}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line text-xs"></i>
              {formatViews(views)}
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{author}</p>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1">
            {comicCats.slice(0, 2).map((cat) => (
              <span
                key={cat}
                className="text-xs bg-secondary-100 text-secondary-700 px-1.5 py-0.5 rounded whitespace-nowrap"
              >
                {categoryNameMap[cat] || cat}
              </span>
            ))}
          </div>
          <span className={`text-xs whitespace-nowrap ${status === '连载中' ? 'text-accent-600' : 'text-secondary-600'}`}>
            {status}
          </span>
        </div>
        <div className="flex items-center justify-between mt-1.5 text-xs text-foreground-400">
          <span>共{chapters}话</span>
        </div>
      </div>
    </Link>
  );
}